/* eslint-disable indent */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default () => {
  const minMaxSchema = Yup.number()
    .typeError(i18n.t('MUST_BE_A_NUMBER_KEY'))
    .min(
      0,
      i18n.t('MIN_VALUE_KEY', {
        value: 0,
      })
    )
    .max(
      2147483647,
      i18n.t('MAX_VALUE_KEY', {
        value: 2147483647,
      })
    )
    .nullable(true);

  return Yup.object().shape({
    name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        40,
        i18n.t('MAX_LENGTH_KEY', {
          value: 40,
        })
      ),
    licenses: Yup.object().shape({
      license_limit: minMaxSchema.required(i18n.t('REQUIRED_FIELD_KEY')),
      increase_license_limit_each: Yup.number()
        .typeError(i18n.t('MUST_BE_A_NUMBER_KEY'))
        .min(
          0,
          i18n.t('MIN_VALUE_KEY', {
            value: 0,
          })
        )
        .max(
          99,
          i18n.t('MAX_VALUE_KEY', {
            value: 99,
          })
        )
        .nullable(true),
      increase_license_reason: Yup.string()
        .nullable()
        .when('increase_license_limit_each', {
          is: increaseLicenseLimit => {
            return Number(increaseLicenseLimit) > 0;
          },
          then: schema => schema.required(i18n.t('REQUIRED_FIELD_KEY')),
        }),
    }),
    easysky_project_id: Yup.string().max(
      8,
      i18n.t('MAX_LENGTH_KEY', {
        value: 8,
      })
    ),
    publication: Yup.object().shape({
      limit_instance_blocking_publications: Yup.number().required(
        i18n.t('REQUIRED_FIELD_KEY')
      ),
    }),
    user_connection: Yup.object().shape({
      service_port: minMaxSchema,
      web_port: minMaxSchema,
    }),
    provider: Yup.object().shape({
      region: Yup.string().when('type', {
        is: 'multicloud',
        then: Yup.string().nullable(true),
        otherwise: Yup.string()
          .required(i18n.t('REQUIRED_FIELD_KEY'))
          .nullable(false),
      }),
    }),
  });
};
